<script setup>
import { useScheduleItemStore } from "@/stores/ScheduleItemStore"
import { computed } from 'vue'

const props = defineProps({
    day: {}
})

const store = useScheduleItemStore()

const currentWorkshop = (wsID) => {
    return store.workshops.find((ws) => {
        return ws.id === wsID
    })
}

const currentGeneralSession = (gsID) => {
    return store.generalSessions.find((gs) => {
        return gs.id === gsID
    })
}

const startTimeMinutes = (dateString) => {
    return new Date(dateString).getMinutes()
}
const startTimeHours = (dateString) => {
    return new Date(dateString).getHours()
}
const continuousWorkshops = (day) => {
   //  console.log(day)
    return day.continuousTracks.filter((track) => {
        return track.type === 'ws'
    })
}
const duration = (start, end) => {
    return (new Date(end) - new Date(start)) / 60000
}

const continuousGeneralSessions = (day) => {
    return day.continuousTracks.filter((track) => {
        return track.type === 'gs'
    })
}

const day = computed(() => {
    return props.day
})

const handleMetaModal = (item, id, type) => {
    store.setOpenModal( item, id, type )
    store.setModalState( true )
}

</script>
<template>
<a v-for="(continuousTrack, index) in continuousWorkshops(day)"
    :key="index"
    :href="`#${ continuousTrack.slug }`"
    :class="`meta-schedule-itemm meta-schedule-item--ws-title ${ continuousTrack.slug } time-offset--${ startTimeMinutes(continuousTrack.starts_at) } open-detail`"
    :style="`grid-row: time-${ startTimeHours(continuousTrack.starts_at) } / span1; grid-column: loc-${ continuousTrack.location } / span 1`"
    :data-title="continuousTrack.title"
    :data-convenors="currentWorkshop(continuousTrack.id).ws_convenors"
    :data-location="continuousTrack.location_name"
    @click.prevent="handleMetaModal(currentWorkshop(continuousTrack.id), continuousTrack.title, 'ws')"
>
    <span class="ws-title">{{ continuousTrack.short_name }}</span>
    <svg class="svgicon icon-info"><use xlink:href="#svg-info"></use></svg>
</a>

<div v-for="(continuousTrack, index) in continuousWorkshops(props.day)"
    :key="index"
    :class="`meta-schedule-item meta-schedule-item--ws ${ continuousTrack.slug } time-offset--${ startTimeMinutes(continuousTrack.starts_at) } open-detail`"
    :style="`--duration: ${ duration( continuousTrack.starts_at, continuousTrack.ends_at ) }; grid-row: time-${ startTimeHours(continuousTrack.starts_at) }; grid-column: loc-${ continuousTrack.location } / span 1`"
></div>

<a v-for="(continuousTrack, index) in continuousGeneralSessions(props.day)"
    :key="index"
    :href="`#${ continuousTrack.slug }`"
    :class="`meta-schedule-item meta-schedule-item--gs-title ${ continuousTrack.slug } time-offset--${ startTimeMinutes(continuousTrack.starts_at) } open-detail`"
    :style="`grid-row: time-${ startTimeHours(continuousTrack.starts_at) } / span1; grid-column: loc-${ continuousTrack.location } / span 1`"
    :data-title="continuousTrack.title"
    :data-location="continuousTrack.location_name"
    @click.prevent="handleMetaModal(currentGeneralSession(continuousTrack.id), continuousTrack.title, 'gs')"
>
    <span class="gs-title">{{ continuousTrack.short_name }}</span>
    <svg class="svgicon icon-info"><use xlink:href="#svg-info"></use></svg>
</a>

<div v-for="(continuousTrack, index) in continuousGeneralSessions(props.day)"
    :key="index"
    :class="`meta-schedule)item meta-schedule-item--gs ${ continuousTrack.slug } time-offset--${ startTimeMinutes(continuousTrack.starts_at) } open-detail`"
    :style="`--duration: ${ duration( continuousTrack.starts_at, continuousTrack.ends_at ) }; grid-row: time-${ startTimeHours(continuousTrack.starts_at) }; grid-column: loc-${ continuousTrack.location } / span 1`"
></div>

</template>